import React from "react";

const AppContext = React.createContext({
  theme: "dark",
  updateTheme: () => {},
  balanceList: [],
  updateBalanceList: () => {},
  logoutUser: () => {},
  liquidityPools: [],
  stakingConfig: {},
  formatCurrency: () => {},
});

export default AppContext;
